import { Component } from '@angular/core';

@Component({
  selector: 'app-our-gallery',
  templateUrl: './our-gallery.component.html',
  styleUrl: './our-gallery.component.scss'
})
export class OurGalleryComponent {
  constructor() { }

  ngOnInit(): void {
  }
}
